import { SelectItemsComponent } from './select-content.component';
import { SelectOptionComponent } from './select-option.component';
import { SelectComponent } from './select.component';

export const SelectImports = [SelectComponent, SelectOptionComponent, SelectItemsComponent];
